/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Language_Switchtofrench2Inputs */

const en_language_switchtofrench2 = /** @type {(inputs: Language_Switchtofrench2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Affichage en français`)
};

const fr_language_switchtofrench2 = /** @type {(inputs: Language_Switchtofrench2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Affichage en français`)
};

/**
* | output |
* | --- |
* | "Affichage en français" |
*
* @param {Language_Switchtofrench2Inputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
const language_switchtofrench2 = /** @type {((inputs?: Language_Switchtofrench2Inputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Language_Switchtofrench2Inputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_language_switchtofrench2(inputs)
	return fr_language_switchtofrench2(inputs)
});
export { language_switchtofrench2 as "language_switchToFrench" }